import { faPlus } from "@fortawesome/pro-light-svg-icons";
import { faTrash } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Form, InputNumber } from "antd";
import FormSelect from "components/form/FormSelect";
import { get } from "lodash";
import { useTranslation } from "react-i18next";

export default function RelatedSKUsForm() {
   const { t } = useTranslation();
   return (
      <Card className="mt-[20px]">
         <div className="flex gap-[16px] items-center">
            <div className="flex-1">
               <FormSelect
                  name="originalVariantSku"
                  rules={[{ required: true, message: 'Missing value' }]}
                  reference={{
                     labelProp: 'variantSku',
                     valueProp: 'variantSku',
                     model: 'product-variants',
                     searchKey: 'variantSku',
                  }}
                  placeholder={t('common.input.originalSKU.placeholder')}
                  label={t('common.input.originalSKU.label')}
               />
            </div>
            <div className="flex-1">
               <Form.Item
                  name="originalPriority"
                  rules={[{ required: true, message: 'Missing last name' }]}
                  label={t('common.input.priority.label')}
               >
                  <InputNumber
                     min={0}
                  />
               </Form.Item>
            </div>
            <Form.Item
               noStyle
               shouldUpdate={(p, c) =>
                  get(p, 'productVariantRelateds')?.length !== get(c, 'productVariantRelateds')?.length
               }
            >
               {({ getFieldValue }) => {
                  const productVariantRelateds = getFieldValue('productVariantRelateds');

                  return productVariantRelateds?.length > 1 ? <div className="w-[13px]" /> : <></>
               }}
            </Form.Item>
         </div>
         <Form.List name="productVariantRelateds" initialValue={[{}]}>
            {(fields, { add, remove }) => (
            <>
               {fields.map(({ key, name, ...restField }) => (
                  <div key={`productVariantRelateds-${key}`} className="flex gap-[16px] items-center">
                     <div className="flex-1">
                        <FormSelect
                           nameFormItem={[name, 'relatedVariantSku']}
                           name={['productVariantRelateds', name, 'relatedVariantSku']}
                           rules={[{ required: true, message: 'Missing value' }]}
                           reference={{
                              labelProp: 'variantSku',
                              valueProp: 'variantSku',
                              model: 'product-variants',
                              searchKey: 'variantSku',
                           }}
                           placeholder={t('common.input.newSKU.placeholder')}
                           label={t('common.input.newSKU.label')}
                        />
                     </div>
                     <div className="flex-1">
                        <Form.Item
                           {...restField}
                           name={[name, 'priority']}
                           rules={[{ required: true, message: 'Missing last name' }]}
                           label={t('common.input.priority.label')}
                        >
                           <InputNumber
                              min={0}
                           />
                        </Form.Item>
                     </div>
                     {fields?.length > 1 && (
                        <FontAwesomeIcon icon={faTrash} onClick={() => remove(name)} className="mt-[12px] w-[13px]" /> 
                     )}
                  </div>
               ))}
               <div onClick={() => add()} className="border-[1px] border-[#6852D3] rounded-[5px] p-[10px] flex items-center mt-[10px] w-max cursor-pointer">
                  <FontAwesomeIcon icon={faPlus} className="text-[12px] text-[#6852D3] mr-[5px]" />
                  <div className="text-[12px] text-[#6852D3] leading-[1.2em]">{t('settings.sku.addNewSKU')}</div>
               </div>
            </>
            )}
         </Form.List>
      </Card>
   )
}